import { Check } from "lucide-react";
import { IMAGES } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

const VALUES = [
  "Profissionalismo e cuidado em cada visita",
  "Comunicação direta, sem intermediários",
  "Orçamentos claros, sem surpresas",
  "Respeito pelo seu espaço e pelos seus horários",
];

export default function About() {
  return (
    <section id="sobre" data-testid="about-section" className="scroll-mt-24 bg-sand/60 py-20 sm:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <Reveal>
          <div className="relative">
            <div className="overflow-hidden rounded-[2rem] border border-stone2 shadow-[0_32px_70px_-30px_rgba(18,37,26,0.35)]">
              <img
                src={IMAGES.about}
                alt="Jardineiro da EcoJard a cuidar de um jardim"
                loading="lazy"
                className="h-[24rem] w-full object-cover sm:h-[30rem]"
              />
            </div>
            <div className="absolute -bottom-5 right-6 rounded-2xl bg-pine px-6 py-4 text-ivory shadow-xl">
              <p className="font-serif text-lg leading-tight">Serviço próximo,</p>
              <p className="font-serif text-lg italic leading-tight text-lime-300">do início ao fim.</p>
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHead
            overline="Sobre a EcoJard"
            title="Uma empresa portuguesa, próxima de cada cliente"
          />
          <Reveal delay={0.15}>
            <p className="mt-6 text-base leading-relaxed text-moss sm:text-lg">
              A EcoJard é uma empresa portuguesa de jardinagem e manutenção de espaços verdes.
              Trabalhamos de forma próxima com cada cliente, do primeiro contacto ao último
              corte de relva, com comunicação direta e o cuidado de quem trata cada jardim
              como se fosse seu.
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <ul className="mt-8 flex flex-col gap-4">
              {VALUES.map((v) => (
                <li key={v} className="flex items-start gap-3 text-base font-medium text-ink">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime-100 text-lime-700">
                    <Check size={14} strokeWidth={3} />
                  </span>
                  {v}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.3}>
            <a
              data-testid="about-quote-button"
              href="#orcamento"
              className="mt-10 inline-flex items-center gap-2 rounded-full bg-pine px-8 py-4 text-base font-semibold text-ivory transition-colors duration-200 hover:bg-pine-hover"
            >
              Falar connosco
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
